export enum ProcessActionTypes {
    // Снять с контроля
    RemoveFromControl,
    // Сменить ответственного по маршруту
    ChangeController,
}
